import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_academic from "../../core/service/api_academic";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import TabsMobile from "../__template/TabsMobileComponent";
import Calendar from "react-calendar";
import topCalendar from "../../assets/images/icon_academic/top-calendar.svg";
import TopCalendarDynamic from "../../assets/images/icon_academic/top-calendar-dynamic";
import next from "../../assets/images/icon_academic/next-arrow.svg";
import prev from "../../assets/images/icon_academic/prev-arrow.svg";
import { setLoading } from "../../core/feature/config/configSlice";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { spawn } from "child_process";
import { i18n } from "../../translations/i18n";
import { setLanguage } from "../../core/feature/language/languageSlice";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";

const CalendarMobile = () => {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const language: String = useAppSelector((state) => state.language.language);
  const token: String = useAppSelector((state) => state.token.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  const [selectedDate, setSelectedDate] = useState(moment());
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );

  const [listEvents, setListEvents] = useState<any>([]);

  const [agendaPerDay, setAgendaPerDay] = useState<any>([]);

  const [daysBefore, setDaysBefore] = useState<any>([]);

  function gett(all: any) {
    let temp: any = [];

    let start = Number(moment(startDate).format("DD"));
    let end = Number(moment(endDate).format("DD"));
    for (let x = start; x <= end; x++) {
      let inputtedDate = String(x).length == 1 ? "0" + x : x;
      inputtedDate = `${moment(startDate).format("YYYY-MM-")}${inputtedDate}`;
      temp.push({
        tgl: inputtedDate,
        content: [],
      });
    }

    all.map((item: any) => {
      let tglStart = moment(item.startDate).format("YYYY-MM-DD");
      let tglEnd = moment(item.endDate).format("YYYY-MM-DD");
      let color = item.color;
      if (String(tglStart) !== String(tglEnd)) {
        for (
          var m = moment(tglStart);
          m.isBefore(moment(tglEnd).add(1, "days"));
          m.add(1, "days")
        ) {
          console.log(`${m.format("YYYY-MM-DD")}`);
          temp.map((item: any, key: any) => {
            if (item.tgl == m.format("YYYY-MM-DD")) {
              temp[key].content.push(color);
            }
          });
        }
      } else {
        temp.map((item: any, key: any) => {
          if (item.tgl == tglStart) {
            temp[key].content.push(color);
          }
        });
      }
    });
    console.log(temp);
    setAgendaPerDay(temp);

    let howManyDay = Number(moment(startDate).day()) - 1;
    if (howManyDay == -1) {
      howManyDay = 6;
    }
    let x: any = [];
    for (let i = 0; i < howManyDay; i++) {
      x.push("");
    }
    setDaysBefore(x);
  }

  const env = Config.BaseUrlDev;

  useEffect(() => {
    console.log("tes", location.pathname.split("/")[2]);
    if (location.pathname.split("/")[2] != undefined) {
      dispatch(setToken(location.pathname.split("/")[2]));
      if (location.pathname.split("/")[3] != undefined) {
        var lang = location.pathname.split("/")[3];
        i18n.changeLanguage(lang);
        dispatch(setLanguage(lang));
      }
      API.credentialCheck().then((resCredential) => {
        dispatch(setUser(resCredential.data.user));
        navigate("/calendar");
      });
    } else {
      if (user == undefined) {
        navigate("/login", { replace: true });
      } else {
        getData();
      }
    }
  }, [selectedDate, location.pathname.split("/")[2]]);

  function getData() {
    dispatch(setLoading(true));
    api_academic
      .getAgenda(startDate, endDate)
      .then((res: any) => {
        dispatch(setLoading(false));
        console.log(res.data.content);
        setListEvents(res.data.content);
        gett(res.data.content);
      })
      .catch((e) => {
        dispatch(setLoading(false));
      });
  }

  function prevMonth() {
    let tempSelectedDate = moment(selectedDate).add(-1, "month");
    setSelectedDate(tempSelectedDate);
    setStartDate(tempSelectedDate.startOf("month").format("YYYY-MM-DD"));
    setEndDate(tempSelectedDate.endOf("month").format("YYYY-MM-DD"));
  }

  function nextMonth() {
    let tempSelectedDate = moment(selectedDate).add(1, "month");
    setSelectedDate(tempSelectedDate);
    setStartDate(tempSelectedDate.startOf("month").format("YYYY-MM-DD"));
    setEndDate(tempSelectedDate.endOf("month").format("YYYY-MM-DD"));
  }

  const randomKey = () => {
    let r = (Math.random() + 1).toString(36).substring(7);
    return r;
  };

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <div className="bg-white px-8 pt-8 pb-3  sticky top-0">
          <TabsMobile
            name={`${t("CALENDAR.title")}`}
            backUrl={"home"}
          ></TabsMobile>
        </div>
        <div className="min-h-screen h-full mb-6 px-4 py-6 bg-psp-primary top-to-bottom">
          <section className="pt-1">
            {/* <img src={topCalendar} className="w-full" alt="" /> */}
            <TopCalendarDynamic accent={customApp.app_accent_color} secondary={customApp.app_secondary_accent_color} />
            <div className="bg-white">
              <div className="flex flex-row justify-around py-2">
                <div
                  onClick={() => {
                    prevMonth();
                  }}
                >
                  <img src={prev} alt="" />
                </div>
                <div className="font-bold">
                  {language == "en"
                    ? t(moment(selectedDate).lang("en").format("MMMM YYYY"))
                    : t(moment(selectedDate).lang("id").format("MMMM YYYY"))}
                  {/* t{moment(selectedDate).lang("en").format("MMMM YYYY")} */}
                </div>
                <div
                  onClick={() => {
                    nextMonth();
                  }}
                >
                  <img src={next} alt="" />
                </div>
              </div>
              <div className="grid grid-cols-7">
                <div className="text-center">{t("CALENDAR.day.mon")}</div>
                <div className="text-center">{t("CALENDAR.day.tues")}</div>
                <div className="text-center">{t("CALENDAR.day.wed")}</div>
                <div className="text-center">{t("CALENDAR.day.thurs")}</div>
                <div className="text-center">{t("CALENDAR.day.fri")}</div>
                <div className="text-center">{t("CALENDAR.day.sat")}</div>
                <div className="text-center">{t("CALENDAR.day.sun")}</div>
              </div>
              <div className="grid grid-cols-7">
                {daysBefore.map((item: any, key: any) => {
                  return <div className="text-center" key={randomKey()}></div>;
                })}
                {agendaPerDay.map((item: any, key: any) => {
                  let content = item.content;
                  return (
                    <div className="text-center h-11 flex justify-center items-center" key={randomKey()} 
                    style={{
                      background: moment().format("LL") === moment(item.tgl).format("LL") ? ` ${customApp.app_accent_color}` : "",
                      color: (moment().format("LL") === moment(item.tgl).format("LL")) && isDarkColor(customApp.app_accent_color) ? 'white' : 'black',
                      borderRadius: "10px",
                    }}
                    >
                      <div>
                      {moment().format("LL") ==
                      moment(item.tgl).format("LL") ? (
                        <span className=" font-bold">
                          {moment(item.tgl).format("D")}
                        </span>
                      ) : (
                        moment(item.tgl).format("D")
                      )}
                      {/* {moment(item.tgl).format("D")} */}
                      <div className="flex flex-row justify-center ">
                        {content.map((item: any, key: any) => {
                          if (key < 3) {
                            return (
                              <div
                                key={key}
                                className="w-2 h-2 rounded-xl"
                                style={{ backgroundColor: item }}
                              ></div>
                            );
                          }
                        })}
                      </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
          <section className="p-2 pb-3 bg-white rounded-b-xl">
            <div className="font-bold mb-2">{t("CALENDAR.description")}</div>
            {listEvents.map((item: any, key: any) => {
              if (item.startDate == item.endDate) {
                return (
                  <div className="flex flex-row" key={randomKey()}>
                    <div
                      className="w-1/5 text-center"
                      style={{ color: item.color }}
                    >
                      {moment(item.startDate).format("DD")}
                    </div>
                    <div className="w-4/5">{item.description}</div>
                  </div>
                );
              } else {
                return (
                  <div className="flex flex-row">
                    <div
                      className="w-1/5 text-center"
                      style={{ color: item.color }}
                      key={randomKey()}
                    >
                      {moment(item.startDate).format("DD")} -{" "}
                      {moment(item.endDate).format("DD")}
                    </div>
                    <div className="w-4/5">{item.description}</div>
                  </div>
                );
              }
            })}
            {listEvents.length == 0 && (
              <div className="p-2 text-center ">{t("OTHER.dataNotFound")}</div>
            )}
          </section>
        </div>
      </div>
    </>
  );
};

export default CalendarMobile;
